export default "__VITE_ASSET__DFi7D9Qm__"